import { render, staticRenderFns } from "./CommonIcon.vue?vue&type=template&id=16ff7cc8&scoped=true&lang=pug&"
import script from "./CommonIcon.vue?vue&type=script&lang=js&"
export * from "./CommonIcon.vue?vue&type=script&lang=js&"
import style0 from "./CommonIcon.vue?vue&type=style&index=0&id=16ff7cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff7cc8",
  null
  
)

export default component.exports